var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1076.976,
    height: 923.273,
    viewBox: "0 0 1076.976 923.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_242",
    "data-name": "Trazado 242",
    d: "M696.093,223.05a224.907,224.907,0,0,1-157.947-64.7L476.324,97.407a74.968,74.968,0,0,0-52.55-21.557H150.132c-40.611,0-73.735,32.109-74.5,72.207l3.411,74.993H4.536l-3.411-73.6c0-81.3,66.713-147.2,149.007-147.2H423.708A149.938,149.938,0,0,1,529.04,45.4l61.689,60.941A149.94,149.94,0,0,0,696.093,149.45Z",
    transform: "translate(21.97 -2.25)",
    fill: "#d0740b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_243",
    "data-name": "Trazado 243",
    d: "M939.5,77.3H138.335a68.247,68.247,0,0,0-50.912,22.97A71.585,71.585,0,0,0,69.664,154.22l43.911,493.865c3.216,36.328,32.963,64.157,68.61,64.187h713.46c35.646-.03,65.393-27.859,68.61-64.187l43.911-493.865A71.587,71.587,0,0,0,990.4,100.268,68.244,68.244,0,0,0,939.5,77.3ZM138.335,6.75A136.5,136.5,0,0,0,36.5,52.7,143.169,143.169,0,0,0,.993,160.616L44.9,654.481C51.354,727.148,110.88,782.8,182.185,782.823h713.46c71.305-.025,130.831-55.675,137.281-128.342l43.911-493.865a143.176,143.176,0,0,0-35.514-107.924A136.487,136.487,0,0,0,939.5,6.75Z",
    transform: "translate(-0.428 140.45)",
    fill: "#d0740b",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.9851b459.svg";
export { ForwardRef as ReactComponent };